import { SegmentedMessage } from 'sms-segments-calculator'
import * as R from 'ramda'

const TEXT_ENGLISH = 'GSM-7'

export const validateGsm = (values, value) => {
  if (R.isEmpty(value)) {
    return true
  }
  const segmentedMessage = new SegmentedMessage(value)

  return (
    segmentedMessage.encodingName === TEXT_ENGLISH &&
    segmentedMessage.segmentsCount === 1
  )
}
